import api from '../../api'

export default function getOffers(brandId,offerId) {
  return api.delete(`/brands/manage/${brandId}/offers/${offerId}`);
}